const InitialHistoric ={
    isLoading: true,
    isLoadingList: true,
    listData: null,
    graphData: null,
    pagination: null,
    analysisData: null,
    listAllData: null,
    listOperationMode: null,
    multiData: null,
    onlyGraphsData: null,
    isLoadingOnlyGraphs: false,
    city: '',
    cities: [],
    equipamentList: [],
}

export default function HistoricReducer ( PrevState = InitialHistoric, action){
    switch (action.type) {
        case 'changeHistoricLoading':
            return{
                ...PrevState,
                isLoading : action.payload.loading,
            };
        case 'changeHistoricLoadingList':
            return{
                ...PrevState,
                isLoadingList : action.payload.loading,
            };
        case 'changeHistoricListData':
            return{
                ...PrevState,
                listData : action.payload.data,
            };
        case 'changeHistoricGraphData':
            return{
                ...PrevState,
                graphData : action.payload.data,
            };
        case 'changeHistoricPagination':
            return{
                ...PrevState,
                pagination : action.payload.pages,
            };
        case 'ChangeAnalysisData':
            return{
                ...PrevState,
                analysisData : action.payload.analysisData,
            };
        case 'ChangeAlldata':
            return{
                ...PrevState,
                analysisData : action.payload.analysisData,
            };
        case 'ChangeAllData':
            return{
                ...PrevState,
                listAllData : action.payload.listAllData,
            };
        case 'ChangeListOperationMode':
            return{
                ...PrevState,
                listOperationMode : action.payload.listOperationMode,
            };
        case 'changeOnlyGraphsData':
            return{
                ...PrevState,
                onlyGraphsData : action.payload.data,
            };
        case 'changeOnlyGraphsLoading':
            return{
                ...PrevState,
                isLoadingOnlyGraphs : action.payload.loading,
            };
        case 'changeHistoricCity':
            return{
                ...PrevState,
                city : action.payload.city,
            }
        case 'changeHistoricCities':
            return{
                ...PrevState,
                cities : action.payload.cities,
            }
        case 'changeHistoricEquipamentList':
            return{
                ...PrevState,
                equipamentList : action.payload.equipamentList,
            }
        default:
            return PrevState;
    }
}